import { Component, OnInit, TemplateRef } from '@angular/core';
import { Part } from './part';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { PartService } from './part.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';
@Component({
  selector: 'app-part',
  templateUrl: './part.component.html',
  styleUrls: ['./part.component.css']
})
export class PartComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Part';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  partForm: FormGroup;
  parts: Part[] = [];
  partsactive: Part[] = [];
  part: Part;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  partModalRef: BsModalRef;
  operation: string;
  userid: number;
  partid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
    private partservice: PartService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Part_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Part_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Part_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Part_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.partForm = this.formBuilder.group({
      partid: [''],
      part: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'part'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.parts = [];
    this.partsactive = [];
    this.partservice.Get().subscribe(res => {
      this.parts = res;
      if (this.showallstatus == true) {
        this.parts.forEach(data => {
          if (data.active == 1) {
            this.partsactive.push(data);
          }
        });
        this.parts = [];
        this.parts = this.partsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.partsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.parts.forEach(data => {
        if (data.active == 1) {
          this.partsactive.push(data);
        }
      });
      this.parts = [];
      this.parts = this.partsactive;
    }
    else {
      this.showall = true;
      this.parts = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedpart");
    let data = arrays.find(ob => ob['name'] === 'Part');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedpart","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedpart",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.partModalRef.hide();
  }

  get g() { return this.partForm.controls; }

  Post(part: Part) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.partForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.partForm.errors);
    //}
    if ((part.part.trim() == undefined) || (part.part.trim() == '')) {
      this.toastr.error('Part Type should not be empty');
      return;
    }
    
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    part.part = part.part.trim();
    if (this.operation == 'add') {

      part.createdby = this.userid;
      msg = "Record Added Successfully";
      this.partservice.Post(part).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.partModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      part.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.partservice.Put(part).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.partModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.partForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.partForm.value.active = 1;
    } else {
      this.partForm.value.active = 0
    }
  }

  OpenConfirmTemplate(part, template: TemplateRef<any>) {
    if (part.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.part = part;

          this.Delete();

        }
       
      });

  }


  Delete() {
    var msg;
    if (this.part.active == 0) {
      this.part.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.part.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.part.modifiedby = this.userid;
    this.partservice.Delete(this.part).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.partModalRef.hide();
  }
  openPartModal(template: TemplateRef<any>, type, part ?: Part) {
    this.operation = type
    
    if (type == 'update') {
      this.partForm.controls['partid'].setValue(part.partid);
      this.partForm.controls['part'].setValue(part.part);
      this.partForm.controls['active'].setValue(part.active);
      this.part = part;
    }
    if (type == 'add') {
      this.partForm.controls['partid'].setValue(0);
      this.partForm.controls['part'].setValue('');
      this.partForm.controls['active'].setValue(1);
    }
    this.partModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }




}
